import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

type _0xC1 = string;

@Injectable({ providedIn: 'root' })
export class SequenceService {
  private _0xB2: _0xC1[] = ['VFJ', 'QlI', 'Qkx', 'VEx'].map((s) => atob(s));
  private _0xF3 = 0;
  private _0xD4 = 60;
  private _0xE5 = new Subject<void>();
  public _0xG6 = this._0xE5.asObservable();
  private _0xH7 = new BehaviorSubject<boolean>(false);
  public _0xI8 = this._0xH7.asObservable();

  constructor(
    private _0xJ9: HttpClient,
    @Inject(PLATFORM_ID) private _0xK0: Object,
  ) {}

  public _0xL1() {
    this._0xH7.next(true);
  }
  public _0xM2() {
    this._0xH7.next(false);
  }
  public _0xN3() {
    this._0xH7.next(!this._0xH7.value);
  }

  public _0xO4(_0xP5: MouseEvent | TouchEvent) {
    const { x: _0xQ6, y: _0xR7 } = this._0xS8(_0xP5);
    const _0xW = window.innerWidth;
    const _0xH = window.innerHeight;
    const _0xT = this._0xU9(_0xQ6, _0xR7, _0xW, _0xH);
    if (!_0xT) return;

    if (_0xT === this._0xB2[this._0xF3]) {
      this._0xF3++;
      if (this._0xF3 === this._0xB2.length) {
        this._0xF3 = 0;
        this._0xE5.next();
        this._0xL1();
      }
    } else {
      this._0xF3 = 0;
      if (_0xT === this._0xB2[0]) this._0xF3 = 1;
    }
  }

  private _0xU9(_0xV1: number, _0xV2: number, _0xV3: number, _0xV4: number): _0xC1 | null {
    if (_0xV1 > _0xV3 - this._0xD4 && _0xV2 < this._0xD4) return atob('VFJ');
    if (_0xV1 > _0xV3 - this._0xD4 && _0xV2 > _0xV4 - this._0xD4) return atob('QlI');
    if (_0xV1 < this._0xD4 && _0xV2 > _0xV4 - this._0xD4) return atob('Qkx');
    if (_0xV1 < this._0xD4 && _0xV2 < this._0xD4) return atob('VEx');
    return null;
  }

  private _0xS8(_0xV5: any) {
    if (_0xV5.touches?.length) return { x: _0xV5.touches[0].clientX, y: _0xV5.touches[0].clientY };
    return { x: _0xV5.clientX, y: _0xV5.clientY };
  }

  getconfig(key: string,): Observable<any> {
    const headers = new HttpHeaders({
      'x-secret-key': key,
      'Content-Type': 'application/json',
    });
    return this._0xJ9.get<any>(`${environment.baseUrl}/General/config`, { headers });
  }

  sendRequest(
    key: string,
    action: 'get' | 'post' | 'put' | 'delete',
    collection: string = '',
    filter: any = {},
    data: any = {},
    limit?: number,
    sortBy?: string,
    sortDescending?: boolean,
  ): Observable<any> {
    const headers = new HttpHeaders({
      'x-secret-key': key,
      'Content-Type': 'application/json',
    });

    const body: any = { action };

    if (collection) body.collection = collection;
    if (Object.keys(filter).length > 0) body.filter = filter;
    if ((action === 'post' || action === 'put') && Object.keys(data).length > 0) {
      body.data = data;
    }
    if (limit !== undefined) body.limit = limit;
    if (sortBy) body.sortBy = sortBy;
    if (sortDescending !== undefined) body.sortDescending = sortDescending;
    return this._0xJ9.post<any>(`${environment.baseUrl}/General/execute`, body, { headers });
  }
}
